import { Card, Typography, useTheme, CardContent, Box, Tooltip } from "@mui/material";
import CategoryIcon from "features/News/components/CategoryIcon";
import { useParams } from "react-router-dom";
import { ImInfo } from "react-icons/im";
import { useIsMobile } from "hooks/use-breakpoint-checks.hook";
import { categoryDescriptions } from "data/category-description";

function TooltipContent({ category }) {
  console.log(category);
  
  return (
    <Typography variant="body1">{categoryDescriptions[category]}</Typography>
  );
}

export const SidebarCard = ({ category, categoryType }) => {
  const theme = useTheme();

  const { academiaSearch } = useParams();
  const isMobile = useIsMobile();

  const getLabel = () => {
    let label =
      categoryType == null
        ? category
        : categoryType === "wiki"
        ? "Encyclopedia & Dictionary"
        : "Books";

    if (academiaSearch) {
      label = academiaSearch;
    }
    return label;
  };

  const handleInfoClick = () => {};

  return (
    <Card
      elevation={0}
      sx={{
        position: "relative",
        backgroundColor: theme.palette.secondary.main,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        wordBreak: "break-word",
        minHeight: { xs: "20vh", sm: "25vh" },
      }}
    >
      <CategoryIcon
        iconId={category}
        sx={{
          fill: theme.palette.secondary.dark,
          position: "absolute",
          fontSize: "30rem",
          right: "-10rem",
          bottom: "-10rem",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 4.4,
          right: 5.4,
          display: "flex",
          zIndex: 10,
          "& > svg": {
            color: theme.palette.secondary.dark,
          },
          "&:hover > svg": {
            color: theme.palette.primary.dark,
          },
        }}
      >
        <Tooltip
          title={!isMobile ? <TooltipContent category={getLabel()} /> : null}
          placement="right"
          arrow
        >
          <Box>
            <ImInfo
              onClick={handleInfoClick}
              size={16}
              style={{
                p: 1,
              }}
            />
          </Box>
        </Tooltip>
      </Box>
      <CardContent>
        <Typography
          component="div"
          key={category}
          fontSize="2.3rem"
          color="primary.dark"
          fontFamily={theme.typography.h3.fontFamily}
          fontWeight={theme.typography.h3.fontWeight}
        >
          {getLabel()}
        </Typography>
      </CardContent>
    </Card>
  );
};
